import angular from 'angular';

function analyticsService(laboxSSapi,storage, $rootScope) {

  this.isHomePage = true;

  this.$rootScope = $rootScope;
  this.sendReport = (channel, pageName, events, errorMsg, vodTitle, faqTitle, linkName, linkUrl, billingStatus, paperlessbill, pageUrl) => {

    var payload = {
      "channel" : channel,
      "pageName" : pageName,
      "plantId": parseInt(storage.getItem('session', 'plant_id'), 10),
      "homeId": storage.getItem('session', 'home_id'),
      "homePage": this.isHomePage,
      "casn":  storage.getItem('session', 'casn'),
      "accountNumber": storage.getItem('session', 'accno')
    };
    this.isHomePage = false;
    if(pageUrl) {
      payload.pageUrl = pageUrl;
    } else {
      setTimeout(function() {
        payload.pageUrl = window.location.href.split('?')[0];
      }, 150);
    }
    if (events) {
      payload.events = events;
    }
    if (vodTitle) {
      payload.vodTitle = vodTitle;
    }
    if (faqTitle) {
      payload.faqTitle = faqTitle;
    }
    if (errorMsg) {
      payload.errorMsg = errorMsg;
    }
    if (linkName && linkUrl) {
      payload.link = {
        "name": linkName,
        "url": linkUrl,
        "exit": false
      };
    }
    if(billingStatus) {
      payload.billingStatus = billingStatus;
    }
    if(paperlessbill !== null && paperlessbill !== 'undefined') {
      payload.paperlessbill = paperlessbill;
    }
    console.log("sendAnalyticReport paylaod :",payload);

    setTimeout(function() {
      return laboxSSapi.wrap('/api/report', {},'sendAnalyticReport','POST',payload);
    }, 200);
  };

}

analyticsService.$inject = [
  'laboxSSapi',
  'storage',
  '$rootScope'
];

const api = angular.module('analyticsService', ['labox.sse.api','storage'])
  .service('analyticsService', analyticsService);

export default api;



// WEBPACK FOOTER //
// ./client/app/services/appanalytics.js